import { components as reactSelectComponents } from 'chakra-react-select';
import AppFlex from 'version-two/components/chakraLayoutOverrides/AppFlex';
import AppAvatar from 'version-two/components/AppAvatar/AppAvatar';
import AppText from 'version-two/components/Typography/AppText';

function AppSelectCustomMenuList({ children, data, ...props }) {
  return (
    <reactSelectComponents.Option {...props}>
      <AppFlex
        variant="moduleAccessList"
        customStyles={{
          opacity: data?.isDisabled && 0.6,
          justifyContent: 'space-between',
        }}
      >
        <AppFlex>
          <AppAvatar size="sm" name={children} src={data?.imageSrc} />
          <AppText
            title={children}
            customStyles={{ ml: 3 }}
            size="sm"
            variant="bold"
          />
        </AppFlex>

        {data?.unlockedDate && <AppText title={data?.unlockedDate} />}
      </AppFlex>
    </reactSelectComponents.Option>
  );
}

export default AppSelectCustomMenuList;
